module.exports = __webpack_public_path__ + "static/media/icon-window.6af25c7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-window.svg
// module id = 634
// module chunks = 0